<template>
  <div class="skeleton__container">
    <div class="skeleton-box skeleton__title" />
    <div class="skeleton__box">
      <div
        v-for="item in [1, 2, 3, 4, 5, 6]"
        :key="item"
        class="skeleton-box skeleton__item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "frontend/web/src/styles/utils/variables.scss";
.skeleton {
  &__box {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    grid-template-rows: 314px 314px;
    gap: 24px;
    margin-bottom: 80px;
  }

  &__container{
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 80px;
  }

  &__title {
      max-width: 400px;
      height: 36px;
      background-color: $grey-third;
      margin-bottom: 12px;
      border-radius: 12px;
  }

  &__item {
      width: 100%;
      height: 111px;
      background-color: $grey-third;
      border-radius: 16px;
      height: 100%;
  }
}
</style>
